import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL || "https://doctor-appointment-1-yf2j.onrender.com";

export default function GlobalNotificationListener() {
  const navigate = useNavigate();
  const location = useLocation();
  const seenRef = useRef(new Set());

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    if (!userStr) return;
    
    let user;
    try {
      user = JSON.parse(userStr);
    } catch(e) { return; }

    if (!user.id) return;

    // Load previously seen notifications from local storage so we don't toast them again on refresh
    const storedSeen = JSON.parse(localStorage.getItem(`seen_notifications_${user.id}`) || "[]");
    seenRef.current = new Set(storedSeen);

    const checkNotifications = async () => {
      try {
        const res = await fetch(`${API}/api/notifications/user/${user.id}`);
        if (!res.ok) return;
        const notifications = await res.json();
        
        let newSeen = [...seenRef.current];
        let hasNew = false;

        // Iterate backwards to toast oldest first, or just normally
        // The API returns ORDER BY createdAt DESC, so reverse to show older first
        [...notifications].reverse().forEach((n) => {
          if (!seenRef.current.has(n.id)) {
            seenRef.current.add(n.id);
            newSeen.push(n.id);
            hasNew = true;

            // Only popup if it's unread
            if (!n.isRead) {
                // Determine route based on message
                const msg = (n.message || "").toLowerCase();
                let targetRoute = "/notifications";
                
                if (msg.includes("appointment") || msg.includes("booked") || msg.includes("cancelled") || msg.includes("rescheduled")) {
                  targetRoute = "/appointments";
                }

                toast.info(
                  <div>
                    <strong style={{ fontSize: "14px" }}>New Update</strong>
                    <p style={{ margin: "4px 0 0", fontSize: "13px", lineHeight: 1.4 }}>{n.message}</p>
                    <p style={{ margin: "6px 0 0", fontSize: "11px", color: "#6366f1", fontWeight: 700 }}>Click to view</p>
                  </div>, 
                  {
                    onClick: () => navigate(targetRoute),
                    autoClose: 6000,
                    style: { cursor: 'pointer', borderRadius: '12px' }
                  }
                );
            }
          }
        });

        if (hasNew) {
          localStorage.setItem(`seen_notifications_${user.id}`, JSON.stringify(newSeen));
        }
      } catch (err) {
        console.error("Error fetching notifications for polling", err);
      }
    };

    // Initial check
    checkNotifications();

    // Poll every 8 seconds
    const interval = setInterval(checkNotifications, 8000);
    return () => clearInterval(interval);
  }, [navigate]);

  return null;
}
